export default __webpack_public_path__ + "static/media/bg1.269b6df4.jpg";